import React from 'react';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { InputForm } from '../../../shared/components/form_components/input';

interface Props {
  unidade?: FormUnidade;
  onSubmit: (unidade: FormUnidade) => void;
  onCancel?: () => void;
}

interface FormUnidade {
  id_unidade?: number;
  dsc_nome_unidade: string;
}

const FormularioUnidade: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'id_unidade',
      label: 'Id da unidade',
      type: 'number',
      defaultValue: props.unidade?.id_unidade,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'dsc_nome_unidade',
      label: 'Nome da unidade',
      type: 'text',
      defaultValue: props.unidade?.dsc_nome_unidade,
      required: true,
      component: InputForm,
    },
  ];

  return (
    <Form
      fields={fields}
      form_name='unidade'
      is_edit={Boolean(props.unidade)}
      onSubmit={props.onSubmit}
      onCancel={props.onCancel}
    />
  );
};

export { FormularioUnidade };
export type { FormUnidade };
